import React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";

type Props = {
    open: boolean
    title: string
    message: React.ReactNode
    confirmLabel: string
    confirmColor?: 'primary' | 'error'
    onConfirm: () => void
    onCancel: () => void
}
/** Small yes / no dialog for the approve-all and reject-all actions */
export const ConfirmActionDialog: React.FC<Props> = ({
                                                         open,
                                                         title,
                                                         message,
                                                         confirmLabel,
                                                         confirmColor = 'primary',
                                                         onConfirm,
                                                         onCancel,
                                                     }) =>
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
            <DialogContentText>{message}</DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={onCancel}>Cancel</Button>
            <Button variant="contained" color={confirmColor} onClick={onConfirm} autoFocus>{confirmLabel}</Button>
        </DialogActions>
    </Dialog>;
